import { NavigationType } from "../../../stores/session";
import type { CampaignUser, MetaData } from "../../../../types/campaign";
import { getCurrentPhase } from "../../../utils";
import { navigateTo, navigateToPath } from "../../../routing";
import PATHS from "../../../constants/routePaths";
import { StatusReason } from "../../../public/lib/helpers/defaultPolling";

export const defaultHandler = (campaignUser: CampaignUser) => {
  const { current_status: currentStatus, metadata, status_reason: statusReason } = campaignUser;
  const currentPhase = getCurrentPhase(metadata);

  if (currentStatus === "finished") {
    const nextStepPhases = ["thank-you", "thank-you-allow-repeat", "lucky-dip-phase", "duplicate-order"];
    if (nextStepPhases.includes(currentPhase)) {
      navigateTo(NavigationType.Next);
    } else {
      StatusReason.handler(statusReason, navigateToPath);
    }
    return true;
  } else if (currentStatus === "fatal-error") {
    navigateToPath(PATHS.ERROR);
    return true;
  }

  return false;
};

export const createAnonymousStart = (callback: () => void) => (campaignUser: CampaignUser) => {
  const { current_status: currentStatus, metadata, status_reason: statusReason } = campaignUser;
  const currentPhase = getCurrentPhase(metadata);

  if (currentStatus === "finished") {
    if (currentPhase === "thank-you" && statusReason === "link-used") {
      navigateToPath(PATHS.LINK_USED);
    }
    callback();
    return true;
  } else if (currentStatus === "fatal-error") {
    navigateToPath(PATHS.ERROR);
    return true;
  }

  return false;
};

const buildPhase = (metadata: MetaData) => {
  const currentPhase = getCurrentPhase(metadata);
  const components = currentPhase?.split("-") ?? [];
  return components.length >= 2 ? `${components[0]}-${components[1]}` : null;
};

export const waitForNextFinishedPhase =
  (callback: ({ phase, campaignUser }: { phase: string | null; campaignUser: CampaignUser }) => void) =>
  (campaignUser: CampaignUser) => {
    const { current_status: currentStatus, metadata } = campaignUser;

    if (currentStatus === "finished") {
      const phase = buildPhase(metadata);

      callback({ phase, campaignUser });
      return true;
    } else if (currentStatus === "fatal-error") {
      navigateToPath(PATHS.ERROR);
      return true;
    }

    return false;
  };
